import { useCustomer } from '@studio/storeV2/customer/hooks/use-customer';

const useTotalMinutes = (): { totalStreamingMinutes: number; totalViewerMinutes: number } => {
  const { subscriptionDetails, webPlan } = useCustomer();

  const customerStreamMinutes = webPlan?.streamMinutes ?? 0;
  const additionalStreamMinutes = subscriptionDetails?.additionalStreamMinutes ?? 0;
  const totalStreamingMinutes = customerStreamMinutes + additionalStreamMinutes;

  const customerViewerMinutes = webPlan?.viewerMinutes ?? 0;
  const additionalViewerMinutes = subscriptionDetails?.additionalViewerMinutes ?? 0;
  const totalViewerMinutes = customerViewerMinutes + additionalViewerMinutes;

  return {
    totalStreamingMinutes,
    totalViewerMinutes,
  };
};

export default useTotalMinutes;
